import { render, staticRenderFns } from "./SearchCharityPostingWidget.vue?vue&type=template&id=5c1aa71b&scoped=true&"
import script from "./SearchCharityPostingWidget.vue?vue&type=script&lang=js&"
export * from "./SearchCharityPostingWidget.vue?vue&type=script&lang=js&"
import style0 from "./SearchCharityPostingWidget.vue?vue&type=style&index=0&id=5c1aa71b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1aa71b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow})
